export default "__VITE_ASSET__CvAKX7CD__"